import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
import _camelCase from "lodash/camelCase";
import _cloneDeep from "lodash/cloneDeep";
var _excluded = ["text", "url", "type", "usePlansDuration"];
import "core-js/modules/es.regexp.exec.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import { useShowHidePricingFormWithZip } from "../../Utility/Hooks";
import { sanitizeContent, processRichTextContent } from "../../Utility/Utility";
import { Button } from "../../Button/Button/Button";
import { Image } from "../../Image/Image/Image";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { PricingForm } from "../../Price/PricingForm/PricingForm";
import { OfferBanner } from "../../Banner/OfferBanner/OfferBanner";
import { MatchHeightElement } from "../../Utility/MatchHeight/MatchHeightElement";
import { ScrollTransform } from "../../ScrollTransform/ScrollTransform";
import styles from "./Tout.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var toutAlign = ['left', 'center', 'left-center', 'center-left'];
export var toutPositionHoriz = ['left', 'center', 'right'];
export var toutPositionVert = ['top', 'center', 'bottom'];
var defaultSubheadingTypog = 'headline5';
var defaultSubheadingVariant = 'default';
var defaultEyebrowTypog = 'eyebrow3';
var defaultHeadingTypog = 'headline3';
export var Tout = function Tout(_ref) {
  var _offerBanner$popup;
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    _ref$bodyText = _ref.bodyText,
    bodyText = _ref$bodyText === void 0 ? '' : _ref$bodyText,
    _ref$contentMaxWidth = _ref.contentMaxWidth,
    contentMaxWidth = _ref$contentMaxWidth === void 0 ? '' : _ref$contentMaxWidth,
    button = _ref.button,
    secondButton = _ref.secondButton,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? {
      text: '',
      typog: defaultEyebrowTypog,
      variant: 'default'
    } : _ref$eyebrow,
    _ref$footnoteText = _ref.footnoteText,
    footnoteText = _ref$footnoteText === void 0 ? '' : _ref$footnoteText,
    _ref$footnoteBelowCTA = _ref.footnoteBelowCTA,
    footnoteBelowCTA = _ref$footnoteBelowCTA === void 0 ? false : _ref$footnoteBelowCTA,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? {
      ariaLevel: 3,
      text: '',
      typog: defaultHeadingTypog,
      variant: 'default'
    } : _ref$heading,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? {
      typog: defaultSubheadingTypog,
      text: '',
      ariaLevel: 4,
      variant: defaultSubheadingVariant
    } : _ref$subheading,
    subheadingPrice = _ref.subheadingPrice,
    icon = _ref.icon,
    errorMessage = _ref.errorMessage,
    pricing = _ref.pricing,
    _ref$showPricingForm = _ref.showPricingForm,
    showPricingFormInit = _ref$showPricingForm === void 0 ? false : _ref$showPricingForm,
    _ref$positionHoriz = _ref.positionHoriz,
    positionHoriz = _ref$positionHoriz === void 0 ? 'left' : _ref$positionHoriz,
    _ref$positionVert = _ref.positionVert,
    positionVert = _ref$positionVert === void 0 ? 'top' : _ref$positionVert,
    offerBanner = _ref.offerBanner,
    _ref$scrollTransformB = _ref.scrollTransformBodyScale,
    scrollTransformBodyScale = _ref$scrollTransformB === void 0 ? false : _ref$scrollTransformB,
    mobilePaddingBottom = _ref.mobilePaddingBottom,
    _ref$breakpoint = _ref.breakpoint,
    breakpoint = _ref$breakpoint === void 0 ? 'small' : _ref$breakpoint,
    _ref$processJSON = _ref.processJSON,
    processJSON = _ref$processJSON === void 0 ? false : _ref$processJSON;
  var _useShowHidePricingFo = useShowHidePricingFormWithZip(showPricingFormInit),
    autoFocus = _useShowHidePricingFo.autoFocus,
    showPricingForm = _useShowHidePricingFo.showPricingForm,
    onZipClick = _useShowHidePricingFo.onZipClick;
  var headingTextAdjustment = heading !== null && heading !== void 0 && heading.text && processJSON ? sanitizeContent(heading === null || heading === void 0 ? void 0 : heading.text) : heading === null || heading === void 0 ? void 0 : heading.text;
  var subheadingTextAdjustment = subheading !== null && subheading !== void 0 && subheading.text && processJSON ? sanitizeContent(subheading === null || subheading === void 0 ? void 0 : subheading.text) : subheading === null || subheading === void 0 ? void 0 : subheading.text;
  var renderButton = function renderButton(button) {
    var text = button.text,
      url = button.url,
      type = button.type,
      usePlansDuration = button.usePlansDuration,
      otherProps = _objectWithoutProperties(button, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      className: styles.ctaButton,
      url: url,
      type: type
    }, otherProps), {}, {
      children: /*#__PURE__*/_jsx(Text, {
        richText: true,
        textElement: "span",
        typog: "bodycopy",
        className: styles.ctaText,
        children: text
      })
    }));
  };
  var secondButtonConditional = function secondButtonConditional(className) {
    if (secondButton !== null && secondButton !== void 0 && secondButton.text) {
      if (positionHoriz === 'center') {
        return /*#__PURE__*/_jsx("div", {
          className: classnames(styles.cta, styles.text, className, styles.secondButton),
          "data-e2e-name": "tout_second_cta",
          children: renderButton(secondButton)
        });
      } else {
        return /*#__PURE__*/_jsx("div", {
          className: classnames(styles.cta, styles.text, styles.secondButton, className === styles.mobileLayout ? styles.mobileAltLayout : styles.desktopAltLayout),
          "data-e2e-name": "tout_second_cta",
          children: renderButton(secondButton)
        });
      }
    }
  };
  var renderBody = function renderBody() {
    var processedBodyText = bodyText && processJSON ? processRichTextContent(bodyText) : bodyText;
    var bodyTextComponent = /*#__PURE__*/_jsx(Text, {
      richText: true,
      className: styles.text,
      typog: "bodycopyLarge",
      "data-e2e-name": "tout_body_text",
      children: processedBodyText
    });
    var scrollTransform = {
      startScrollPercent: 0,
      endScrollPercent: 0.5,
      transforms: [{
        transformFunction: 'scaleX',
        unit: '',
        startValue: 0.75,
        endValue: 1
      }, {
        transformFunction: 'scaleY',
        unit: '',
        startValue: 0.75,
        endValue: 1
      }]
    };
    return scrollTransformBodyScale ? /*#__PURE__*/_jsx(ScrollTransform, _objectSpread(_objectSpread({}, scrollTransform), {}, {
      children: bodyTextComponent
    })) : bodyTextComponent;
  };
  var renderFootnote = function renderFootnote() {
    return footnoteText && /*#__PURE__*/_jsx("div", {
      className: styles.footnote,
      children: /*#__PURE__*/_jsx(Text, {
        richText: true,
        className: styles.text,
        typog: "captionSmall",
        "data-e2e-name": "tout_footnote_text",
        children: footnoteText
      })
    });
  };
  var renderedPricing = pricing ? _cloneDeep(pricing) : false;
  if (renderedPricing && renderedPricing.input) {
    renderedPricing.input.autoFocus = autoFocus;
  }
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.wrapper, styles[_camelCase(align)], styles["breakpoint".concat(_capitalize(breakpoint))], styles["".concat(positionHoriz, "Horiz")]),
    children: /*#__PURE__*/_jsx("div", {
      className: classnames(styles.content, {
        [styles.fullWidth]: /%|px/.test(contentMaxWidth),
        [styles.mobilePaddingBottom]: mobilePaddingBottom
      }),
      "data-e2e-name": "tout_content",
      style: {
        maxWidth: contentMaxWidth,
        paddingBottom: mobilePaddingBottom
      },
      children: /*#__PURE__*/_jsxs(MatchHeightElement, {
        group: "content",
        flex: true,
        valign: positionVert,
        halign: positionHoriz,
        children: [(icon === null || icon === void 0 ? void 0 : icon.image1x) && /*#__PURE__*/_jsx("div", {
          className: classnames(styles.icon),
          children: /*#__PURE__*/_jsx(Image, {
            alt: icon.alt,
            src: icon.image1x,
            width: icon.width || undefined,
            height: icon.height || undefined,
            loading: icon.loading || 'lazy',
            transformations: {
              image1x: {
                width: typeof icon.width === 'string' ? parseInt(icon.width, 10) || undefined : undefined
              },
              image2x: {
                width: typeof icon.width === 'string' ? parseInt(icon.width, 10) * 2 || undefined : undefined
              }
            },
            forceTwoXInSrc: true
          })
        }), (eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) && /*#__PURE__*/_jsx(Text, {
          richText: true,
          className: styles.eyebrow,
          typog: eyebrow !== null && eyebrow !== void 0 && eyebrow.typog ? eyebrow.typog : defaultEyebrowTypog,
          variant: eyebrow.variant,
          children: eyebrow.text
        }), headingTextAdjustment && /*#__PURE__*/_jsx("div", {
          className: styles.headline,
          children: /*#__PURE__*/_jsx(HeadingText, {
            richText: true,
            align: align,
            typog: heading !== null && heading !== void 0 && heading.typog ? heading.typog : defaultHeadingTypog,
            ariaLevel: heading.ariaLevel,
            variant: heading.variant,
            className: "breakpoint".concat(_capitalize(breakpoint)),
            children: headingTextAdjustment
          })
        }), subheadingTextAdjustment && /*#__PURE__*/_jsx("div", {
          className: classnames(styles.subheadline, {
            [styles.pricing]: subheadingPrice
          }),
          children: /*#__PURE__*/_jsx(HeadingText, {
            richText: true,
            align: align,
            typog: subheading !== null && subheading !== void 0 && subheading.typog ? subheading.typog : defaultSubheadingTypog,
            ariaLevel: subheading.ariaLevel,
            variant: subheading.variant,
            className: "breakpoint".concat(_capitalize(breakpoint)),
            children: subheadingTextAdjustment
          })
        }), subheadingPrice && /*#__PURE__*/_jsx("div", {
          className: styles.subheadline,
          children: /*#__PURE__*/_jsx(Text, {
            textElement: "div",
            typog: subheading !== null && subheading !== void 0 && subheading.typog ? subheading.typog : defaultSubheadingTypog,
            variant: subheading ? subheading.variant : defaultSubheadingVariant,
            richText: true,
            children: subheadingPrice
          })
        }), bodyText !== null && renderBody(), (offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$popup = offerBanner.popup) === null || _offerBanner$popup === void 0 ? void 0 : _offerBanner$popup.title) && /*#__PURE__*/_jsx(OfferBanner, _objectSpread({
          className: classnames(styles.offerBanner, styles["breakpoint".concat(_capitalize(breakpoint))])
        }, offerBanner)), !footnoteBelowCTA && renderFootnote(), (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.text) && /*#__PURE__*/_jsx(Text, {
          typog: "bodycopy",
          className: classnames({
            [styles.text]: true,
            [styles.error]: true,
            [styles.errorRed]: errorMessage.red
          }),
          children: errorMessage.text
        }), (button === null || button === void 0 ? void 0 : button.text) && !showPricingForm && /*#__PURE__*/_jsxs("div", {
          className: styles.buttonWrapper,
          children: [/*#__PURE__*/_jsx("div", {
            className: classnames(styles.cta, styles.text, {
              [styles.firstButton]: secondButton === null || secondButton === void 0 ? void 0 : secondButton.text,
              [styles.noPricingForm]: !pricing
            }),
            "data-e2e-name": "tout_cta",
            children: renderButton(button)
          }), !showPricingForm && secondButtonConditional(styles.desktopLayout)]
        }), renderedPricing && /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.flexItems, {
            [styles.flexItems]: secondButton === null || secondButton === void 0 ? void 0 : secondButton.text,
            [styles.centerAlign]: align === 'center',
            [styles.leftCenterAlign]: align === 'left-center'
          }),
          children: [/*#__PURE__*/_jsx("div", {
            className: classnames(styles.text, styles.pricingForm, {
              [styles.marginTop]: showPricingForm,
              [styles.marginRight]: showPricingForm && secondButton
            }),
            children: /*#__PURE__*/_jsx(PricingForm, {
              pricing: renderedPricing,
              isOpen: showPricingForm,
              onZipClick: onZipClick
            })
          }), showPricingForm && secondButtonConditional(styles.desktopLayout)]
        }), secondButtonConditional(styles.mobileLayout), footnoteBelowCTA && renderFootnote()]
      })
    })
  });
};